import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
@Component({
  selector: 'xux-drawer-content',
  templateUrl: './xux-drawer-content.component.html',
  styleUrls: ['./xux-drawer-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXDrawerContentComponent implements OnInit {
  public ngOnInit(): void {}
}
